import { Typography } from '@mui/material';
import type { ReactNode } from 'react';

export const GroupTitle = ({ title }: { title: ReactNode }) => {
  return (
    <Typography
      variant='overline'
      className='w-full cursor-default'
      sx={{
        display: 'block',
        padding: '8px 24px',
        marginY: '12px',
        backgroundColor: 'var(--mui-palette-background-section)',
      }}
    >
      {title}
    </Typography>
  );
};
